import { SR_API_ACTION_JOIN_SUNROOM_CLUB } from 'api/actionTypes';

export default async function joinSunroomClub({ state, apiClient }, { source }) {
  await apiClient.postWithState({
    action: SR_API_ACTION_JOIN_SUNROOM_CLUB,
    state: state,
    payload: {
      source,
    },
    onSuccess(updatedUserRoles) {
      state.set(['currentUser', 'roles'], updatedUserRoles);
    },
    onError(error) {
      throw error;
    },
  });
}
